module.exports = __webpack_public_path__ + "static/img/best-forex-rates.f6999cfe.svg";